import React, { FC, useMemo } from 'react'
import CalendarIcon from '../UI/Icons/Calendar'
import ContentIcon from '../UI/Icons/Content'
import SettingsIcon from '../UI/Icons/Settings'
import TeamIcon from '../UI/Icons/Team'
import ClientsIcon from '../UI/Icons/Clients'
import NotificationBellIcon from '../UI/Icons/NotificationBell'
import HashtagIcon from '../UI/Icons/HashTags';
// import LabelsIcon from '../UI/Icons/Labels'
// import ScoreIcon from '../UI/Icons/Score'
import SocialAcountsIcon from '../UI/Icons/SocialAcounts'
import BackArrowIcon from '../UI/Icons/BackArrow'
// import ReportingIcon from '../UI/Icons/Reporting'
import AnalyticsIcon from '../UI/Icons/Analytics'

import { useSelector, useDispatch } from '../../store'

import { AUTH_ROUTE } from '../../pages/App/routes'
import { generatePath } from 'react-router'
import { SOCIAL_NETWORK } from '../../models/post'
import Roles from '../../models/roles';

type route = {
  name: string
  path: string
  Icon: ({ color }: any) => JSX.Element
  roles:Array<Roles>
}

enum Routes {
  MAIN = 'main',
  SETTINGS = 'settings'
}

const SwitcCustomer: FC<any> = ({ isActiveRoute, currentProject, moveTo }) => {
  const currentRoute = useSelector(
    ({
      router: {
        location: { pathname }
      }
    }) => {
      const currentRoute = Object.values(Routes).find((key) => pathname.includes(key))
      if (!currentRoute) return Routes.MAIN
      return currentRoute
    }
  )

  const { user } = useSelector(({ auth: { user }}) => ({
    user
  }))

  const appRoutes: { [key in string]: route[] } = useMemo(
    () => ({
      [Routes.MAIN]: [
        {
          name: 'Calendar',
          path: AUTH_ROUTE.CALENDAR,
          Icon: CalendarIcon,
          roles:[]
        },
        {
          name: 'Content',
          path: AUTH_ROUTE.CONTENT,
          Icon: ContentIcon,
          roles:[]
        },
        // {
        //   name: 'Reporting',
        //   path: AUTH_ROUTE.REPORTS,
        //   Icon: ReportingIcon
        // },
        {
          name: 'Analytics',
          path: generatePath(AUTH_ROUTE.ANALYTICS, {
            projectId: currentProject.id,
            social: SOCIAL_NETWORK.FACEBOOK_SOCIAL
          }),
          Icon: AnalyticsIcon,
          roles:[]
        }
      ],
      [Routes.SETTINGS]: [
        {
          name: 'Back',
          path: AUTH_ROUTE.CALENDAR,
          Icon: BackArrowIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN, Roles.CONTENT_CREATOR, Roles.INTERNAL_APPROVER, Roles.EXTERNAL_APPROVER ]
        },
        {
          name: 'General',
          path: AUTH_ROUTE.GENERAL_SETTINGS,
          Icon: SettingsIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN ]
        },
        {
          name: 'Team',
          path: '/:projectId/settings/team',
          Icon: TeamIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN ]
        },
        {
          name: 'External Approver',
          path: '/:projectId/settings/client',
          Icon: ClientsIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN ]
        },
        {
          name: 'Notifications',
          path: '/:projectId/settings/notifications',
          Icon: NotificationBellIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN, Roles.CONTENT_CREATOR, Roles.INTERNAL_APPROVER, Roles.EXTERNAL_APPROVER ]
        },
        {
          name: 'Hashtag Pools',
          path: '/:projectId/settings/hashtag',
          Icon: HashtagIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN, Roles.CONTENT_CREATOR ]
        },
        // {
        //   name: 'Notifications',
        //   path: '/:projectId/settings/notifications',
        //   Icon: NotificationBellIcon
        // },
        // {
        //   name: 'Labels',
        //   path: AUTH_ROUTE.LABELS,
        //   Icon: LabelsIcon
        // },
        // {
        //   name: 'Scores',
        //   path: '/:projectId/settings/scores',
        //   Icon: ScoreIcon
        // },
        {
          name: 'Social Accounts',
          path: AUTH_ROUTE.SOCIAL_ACCOUNTS,
          Icon: SocialAcountsIcon,
          roles:[Roles.AGENCY_ADMIN, Roles.SUPER_ADMIN ]
        }
      ]
    }),
    [currentProject]
  )

  return (
    <div className='navigation__pages'>
      <div className='navigation__pages__header'>
        <div className='navigation__pages__header__clamp'>{currentProject.name}</div>
      </div>
      {appRoutes[currentRoute].map(({ path, name, Icon, roles }, key) => (
          (currentRoute === 'settings' && user && roles.includes(user.agency_role)) || (currentRoute !== 'settings')?<div
          key={path}
          className={`navigation__pages__item ${isActiveRoute(path) ? 'active' : ''}`}
          onClick={() => moveTo(path)}
        >
          <div
            className={`navigation__pages__item__icon-${name.toLowerCase().replaceAll(' ', '-')}`}
          >
            <Icon />
          </div>
          {name}
        </div>:null
      ))}
    </div>
  )
}

export default SwitcCustomer
